<template>
  <div class="mask" v-show="$store.state.fileInfo.addFolderShow" @touchmove.prevent ref="maskPosition">
  <div class="dialog">
    <div style="height:3.52rem ">
      <p class="dialog-title">
        <span>新建文件夹</span>
        <span style="color: red;height: 0.61rem;display: block;font-size: 0.32rem;" v-show="errorInfo">{{errorInfo}}</span>
      </p>
      <p class="dialog-content">
        <input type="text" v-model.trim="fileName" @focus="focusAbsolute()" @blur="blurFixed()"/>
      </p>
    </div>
    <p class="dialog-button">
      <span class="cancel" @click="cancel">取消</span><span class="ok" @click="ok" >确定</span>
    </p>
  </div>
</div>
</template>

<script>
  import * as Util from 'util'
  export default {
    data () {
      return {
        fileName: '',
        errorInfo: ''
      }
    },
    methods: {
      cancel () {
        this.$store.commit('setAddFolderShow', false)
      },
      ok () {
        this.errorInfo = Util.validFilename(this.fileName)
        if (this.errorInfo) {
          return
        }
        if (this.$store.state.movecopy.isShow) { // 移动复制中新建文件夹
          this.$store.dispatch('moveCopyAddFolder', this.fileName)
        } else if (this.$store.state.deliveryTransfor.isShow) {
          this.$store.dispatch('deliveryTransforAddFolder', this.fileName)
        } else {
          this.$store.dispatch('addFolder', this.fileName)
          this.$store.commit('setAddFolderShow', false)
        }
      },
      focusAbsolute () {
        var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)           // 解决ios光标错位
        var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        if (isIOS) {
          if (scrollHeight > 0) {
            // document.body.scrollTo(0, 0)
            document.body.scrollTop = 0
            window.scrollTo(0, 300)
          } else {
            window.scrollTo(0, 0)
          }
          this.$refs.maskPosition.style.position = 'absolute'
        }
      },
      blurFixed () {
        this.$refs.maskPosition.style.position = 'fixed'
      }
    },
    watch: {
      '$store.getters.getAddFolderErr': function (val) {
        if (val !== '') {
          this.errorInfo = val
        }
      },
      '$store.state.fileInfo.addFolderShow': function (val) {
        if (val) {
          this.fileName = ''
          this.errorInfo = ''
        }
      }
    },
    components: {
    }
  }
</script>



// WEBPACK FOOTER //
// filelist_add_folder.vue?b9355f3a